import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem,
  TextField
} from "@material-ui/core";

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: {
    costCenterId: string;
    name: string;
    organisation: string;
    isActive: boolean;
  }) => void;
  initialValues?: {
    costCenterId?: string;
    name?: string;
    organisation?: string;
    isActive?: boolean;
  };
  isEdit?: boolean;
}

const organisations = [
  { value: "Bonliva", label: "Bonliva" },
  { value: "BonlivaCare", label: "Bonliva Care" }
];

export function CostCenterEditDialog({
  open,
  onClose,
  onSubmit,
  initialValues,
  isEdit
}: Props) {
  const [costCenterId, setCostCenterId] = useState("");
  const [name, setName] = useState("");
  const [organisation, setOrganisation] = useState("");
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    if (open) {
      setCostCenterId(initialValues?.costCenterId || "");
      setName(initialValues?.name || "");
      setOrganisation(initialValues?.organisation || "");
      setIsActive(initialValues?.isActive ?? true);
    }
  }, [open]);

  const handleSubmit = () => {
    if (!costCenterId || !name || !organisation) return;

    onSubmit({
      costCenterId,
      name,
      organisation,
      isActive
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {isEdit ? "Redigera kostnadsställe" : "Skapa kostnadsställe"}
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Kostnadsställe-ID"
          value={costCenterId}
          onChange={(e) => setCostCenterId(e.target.value)}
          fullWidth
          margin="normal"
          disabled={isEdit}
          helperText={isEdit ? "Kan inte ändras efter skapande" : "Fortnox-identifierare"}
        />
        <TextField
          label="Namn"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          select
          label="Organisation"
          value={organisation}
          onChange={(e) => setOrganisation(e.target.value)}
          fullWidth
          margin="normal"
        >
          {organisations.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </TextField>
        <FormControlLabel
          control={
            <Checkbox
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
              color="primary"
            />
          }
          label="Aktiv"
          style={{ marginTop: 8 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Avbryt</Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={!costCenterId || !name || !organisation}
        >
          {isEdit ? "Spara" : "Skapa"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
